import type { CellContext } from '@tanstack/vue-table';
import { h } from 'vue';
import OrderNumber from './OrderNumber.vue';

export const GetOrderNumberRenderer = () => {
  return (info: CellContext<any, any>) =>
    h(OrderNumber, {
      key: `${info.row.original.id}-${info.row.original.recurring_number}`,
      info,
    });
};
